var render = function render(){var _vm=this,_c=_vm._self._c;return _c('va-form',{attrs:{"id":_vm.id,"item":_vm.item}},[_c('v-row',{attrs:{"justify":"center"}},[_c('v-col',{attrs:{"sm":"6"}},[_c('v-card',[_c('v-card-title',[_vm._v(" "+_vm._s(_vm.title)+" ")]),_c('v-card-text',[_c('va-text-input',{attrs:{"source":"title"}}),_c('va-save-button')],1)],1)],1)],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }